// Read gallery state only. Browsing images must never select a purchase variant.
class RgcProductCaption extends HTMLElement {
  connectedCallback() {
    this.gallery = this.closest('media-gallery');
    this.caption = this.querySelector('[data-caption-text]');
    this.controller = new AbortController();
    this.gallery?.addEventListener('slideshow:select', (event) => {
      if (event.target !== this.gallery.querySelector('slideshow-component')) return;
      this.showMedia(event.detail?.id);
    }, { signal: this.controller.signal });
    // Modules can load after the native gallery's initial selection event.
    customElements.whenDefined('slideshow-component').then(() => {
      if (!this.isConnected) return;
      const slideshow = this.gallery?.querySelector('slideshow-component');
      const slide = slideshow?.slides?.[slideshow.current] || slideshow?.querySelector('slideshow-slide[aria-hidden="false"]');
      this.showMedia(slide?.getAttribute('slide-id'));
    });
  }

  showMedia(id) {
    if (!this.caption) return;
    const entry = Array.from(this.querySelectorAll('[data-media-id]')).find((item) => item.dataset.mediaId === String(id));
    this.caption.textContent = entry ? `Shown in ${entry.dataset.mediaColor}` : '';
    this.caption.hidden = !entry;
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('rgc-product-caption')) {
  customElements.define('rgc-product-caption', RgcProductCaption);
}
